export default function sinceEpoch(seconds) {
  const date = new Date(0);
  date.setUTCSeconds(seconds);
  return date;
}
